import clsx from 'clsx'
import { useMemo } from 'preact/hooks'

export function ResultsSwatches({ result, swatches, onSelectSwatch }) {
  if (!swatches || swatches.length === 0) return null

  const publishedSwatches = useMemo(() => {
    return swatches.filter((swatch) => swatch.published)
  }, [swatches])

  return (
    <>
      <div className="paragraph-sm text-neutrals-secondary-grey md:group-hover/card:hidden">
        {publishedSwatches.length === 1 ? '1 colour' : `${publishedSwatches.length} colours`}
      </div>
      <div className="flex-wrap justify-end hidden w-1/2 gap-1 md:group-hover/card:flex">
        {publishedSwatches.map((swatch) => (
          <Swatch
            key={swatch.handle}
            swatch={swatch}
            onSelectSwatch={onSelectSwatch}
            isCurrentSwatch={swatch.handle === result.handle}
          />
        ))}
      </div>
    </>
  )
}

function Swatch({ swatch, onSelectSwatch, isCurrentSwatch }) {
  function handleClick() {
    onSelectSwatch(swatch.handle)
  }

  const color = useMemo(() => {
    const tag = swatch?.tags?.find((tag) => tag.includes('Hex'))
    if (!tag) return '#a5a5a5'

    return tag.split('-').pop()
  }, [swatch])

  return (
    <button
      className={clsx('block h-4 w-4 rounded-full border', isCurrentSwatch ? 'border-black' : 'border-transparent')}
      onClick={handleClick}
    >
      <span
        style={{ '--bg-custom': color }}
        className="block h-full w-full rounded-full border border-neutrals-light-grey bg-[--bg-custom]"
      />
    </button>
  )
}
